import { Kpi } from './kpi'
import { KpiHistory } from './kpi-history'
import { KpiHistoryEntitySubscriber } from './event-subscriber'
import { KpiQuery } from './kpi-query'
import { KpiMutation } from './kpi-mutation'

export const entities = [Kpi, KpiHistory]
export const resolvers = [KpiQuery, KpiMutation]
export const subscribers = [KpiHistoryEntitySubscriber]
